import React from 'react'
import PropTypes from 'prop-types'
import { withTabs } from './withTabs'
import TabElement from './TabElement'

/**
 *  How to use
 *  Insert React Component as a child of Tabs
 *  <Tabs> ... </Tabs>
 *
 *  Tabs props
 *
 *  Child will accept mainly 3 props to adjust each tab
 *  1. tabValue (required) unique id for each tab
 *  2. tabLabel: label that will be displayed in tab
 *
 */

const CustomTabs = withTabs(TabElement)(
  ({
    children,
    renderTabs,
    renderContent,
    style,
    className,
  }) => (
    <div style={style} className={className}>
      <div style={{ marginBottom: 10 }}>
        {renderTabs(children)}
      </div>
      {renderContent(children)}
    </div>
  )
)

CustomTabs.propTypes = {
  onTouchTab: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)]).isRequired,
}
CustomTabs.Tab = ({
  children,
  style,
  className,
}) => (
  <div style={style} className={className}>{children}</div>
)

export default CustomTabs



// WEBPACK FOOTER //
// ./src/components/Tabs/CustomTabs.js